// extracted by mini-css-extract-plugin
module.exports = {"presenterToolHolder":"CurrentPresenterTool_presenterToolHolder__1gC0C"};